
import { useEffect, useState, useRef } from 'react';

export const useInView = (
  threshold = 0.1,
  options?: { rootMargin?: string }
) => {
  const [isInView, setIsInView] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          if (ref.current) observer.unobserve(ref.current);
        }
      },
      { threshold, rootMargin: options?.rootMargin ?? '0px' }
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, options?.rootMargin]);

  return { ref, isInView };
};

export const staggeredAnimation = (delay = 0) => {
  return {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
      delay,
    },
  };
};

export const fadeInAnimation = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1],
    }
  },
};

export const projectCardAnimation = {
  rest: { 
    scale: 1,
    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
  hover: { 
    scale: 1.02, 
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    transition: {
      duration: 0.3,
      ease: 'easeIn',
    },
  },
};
